type UrlObject = { url: string; name?: string }

// Tuned to keep every download inside the browser's user-activation window:
// 100ms drops files, and clicking with no stagger collapses to a single
// download.
const DOWNLOAD_STAGGER_MS = 400

// Triggers a browser download for each file. Browsers gate rapid programmatic
// downloads, so a naive "reuse one anchor and click it N times" drops files
// (the classic "only 2 of 3 download" symptom). We give each file its own
// freshly-created, DOM-attached anchor and stagger the clicks so the browser
// treats each as a distinct, user-initiated download.
export const downloadFiles = (fileOrFiles: UrlObject[] | UrlObject) => {
  const files = Array.isArray(fileOrFiles) ? fileOrFiles : [fileOrFiles]
  files.forEach(({ url, name }, index) =>
    setTimeout(() => {
      const link = document.createElement('a')
      link.href = url
      if (name !== undefined) link.download = name
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      // Defer removal so the anchor outlives the click's macrotask — robust
      // against callers that later need it alive longer (e.g. target="_blank"
      // or blob URLs that would otherwise be revoked mid-download).
      setTimeout(() => document.body.removeChild(link), 0)
    }, DOWNLOAD_STAGGER_MS * index)
  )
}
